const agentResponseToAgentObject = (response = {}) => {
    return {
        id: response.id,
        name: response.name || response.agent_name || '',
        agentType: response.agent_type || response.agentType || 'GENERIC',
        enabled: typeof response.enabled === 'boolean' ? response.enabled : true,
        createdAt: response.created_at || response.createdAt || null,
        updatedAt: response.updated_at || response.updatedAt || null,
        metadata: response.metadata || {},
    };
};

const agentObjectToAgentRequest = (object = {}) => {
    const request = {
        agent_type: object.agentType,
        enabled: object.enabled,
    };

    if (object.name) {
        request.name = object.name;
    }

    if (object.metadata) {
        request.metadata = object.metadata;
    }

    return request;
};

export { agentResponseToAgentObject, agentObjectToAgentRequest };
